import { Brand } from '../../lib/component-library/components/Logo/Logo'

export const SITE_HEADER_BRANDS = [
  {
    brand: 'shipplay' as Brand,
    url: 'https://www.shipplay.com',
  },
  {
    brand: 'shipsticks' as Brand,
    url: 'https://www.shipsticks.com',
  },
  {
    brand: 'shipskis' as Brand,
    url: 'https://www.shipskis.com',
  },
  {
    brand: 'shipcamps' as Brand,
    url: 'https://www.shipcamps.com',
  },
]

export const SITE_HEADER_LINKS = [
  {
    name: 'How It Works',
    href: '/how-it-works',
  },
  {
    name: 'What Can I Ship?',
    href: '/what-can-i-ship',
  },
  {
    name: 'Order Tracking',
    href: '/track-orders',
  },
]

export const SITE_HEADER_HELP_LINKS = [
  {
    name: 'FAQ',
    href: '/faq',
  },
  {
    name: 'Contact Us',
    href: '/contact',
  },
  {
    name: 'Careers',
    href: '/careers',
  },
]

export const SITE_HEADER_BUTTON = {
  name: 'Get Started',
  href: '/book/ship',
}
